// Central algorithm catalogue. Merges specialty files + adds "coming soon"
// entries for Neurology and Pediatric.

import { CARDIOVASCULAR_ALGOS } from "./cardiovascular";
import { RESPIRATORY_ALGOS } from "./respiratory";
import { ANESTESI_ALGOS } from "./anestesi";

// Placeholder rows (available: false) so the counters and list still render
// for specialties that will ship in v2.2.
const placeholder = (id, specialty, titleId, titleEn, descId = "", descEn = "") => ({
  id,
  specialty,
  available: false,
  title: { id: titleId, en: titleEn },
  desc: { id: descId, en: descEn },
});

const NEURO_ALGOS = {
  stroke: placeholder("stroke", "neurology", "Code Stroke", "Code Stroke", "Window trombolisis/trombektomi", "Thrombolysis / thrombectomy window"),
  sse: placeholder("sse", "neurology", "Status Epileptikus", "Status Epilepticus"),
  icp: placeholder("icp", "neurology", "Peningkatan Tekanan Intrakranial", "Elevated Intracranial Pressure"),
  "gcs-approach": placeholder(
    "gcs-approach",
    "neurology",
    "Penurunan Kesadaran Mendadak",
    "Sudden Decreased Consciousness",
    "Pendekatan berbasis GCS",
    "GCS-based approach"
  ),
};

const PED_ALGOS = {
  neo: placeholder("neo", "pediatric", "Resusitasi Neonatus", "Neonatal Resuscitation"),
  pals: placeholder("pals", "pediatric", "PALS — Henti Jantung Anak", "PALS — Paediatric Cardiac Arrest"),
  psepsis: placeholder("psepsis", "pediatric", "Sepsis Pediatrik", "Paediatric Sepsis"),
  fs: placeholder("fs", "pediatric", "Kejang Demam", "Febrile Seizure"),
};

// Anestesi additional coming-soon entry.
const cico = placeholder(
  "cico",
  "anestesi",
  "Can't Intubate Can't Oxygenate",
  "Can't Intubate Can't Oxygenate"
);

export const SPECIALTIES = {
  cardiovascular: {
    key: "cardiovascular",
    name: { id: "Cardiovascular", en: "Cardiovascular" },
    color: "teal",
    order: ["acls", "hf", "acs", "brady", "tachy", "htn"],
    algorithms: CARDIOVASCULAR_ALGOS,
  },
  respiratory: {
    key: "respiratory",
    name: { id: "Respiratory", en: "Respiratory" },
    color: "sky",
    order: ["arf", "asma", "ppok", "ards", "choking", "vent"],
    algorithms: RESPIRATORY_ALGOS,
  },
  neurology: {
    key: "neurology",
    name: { id: "Neurology", en: "Neurology" },
    color: "purple",
    order: ["stroke", "sse", "icp", "gcs-approach"],
    algorithms: NEURO_ALGOS,
  },
  pediatric: {
    key: "pediatric",
    name: { id: "Pediatric", en: "Pediatric" },
    color: "amber",
    order: ["neo", "pals", "psepsis", "fs"],
    algorithms: PED_ALGOS,
  },
  anestesi: {
    key: "anestesi",
    name: { id: "Anestesi & Airway", en: "Anesthesia & Airway" },
    color: "stone",
    order: ["da", "rsi", "mh", "last", "cico"],
    algorithms: { ...ANESTESI_ALGOS, cico },
  },
};

export function getAlgorithm(specialtyKey, algoId) {
  const s = SPECIALTIES[specialtyKey];
  if (!s) return null;
  return s.algorithms[algoId] || null;
}

export function specialtyCounts(specialtyKey) {
  const s = SPECIALTIES[specialtyKey];
  if (!s) return { available: 0, total: 0 };
  const list = s.order.map((id) => s.algorithms[id]).filter(Boolean);
  return {
    available: list.filter((a) => a.available).length,
    total: list.length,
  };
}
